import { render, staticRenderFns } from "./HomeClients.vue?vue&type=template&id=8c44ecea&"
import script from "./HomeClients.vue?vue&type=script&lang=js&"
export * from "./HomeClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports